// @ts-nocheck
import { useEffect } from "react";

const SITE_URL = "https://orionintelligence.net";
const DEFAULT_IMAGE = `${SITE_URL}/og-image-v2.jpg?v=2`;

function upsertMeta(attribute, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SeoHead({
  title,
  description,
  canonical,
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
}) {
  useEffect(() => {
    const nextTitle = title || "Orion Intelligence";
    const nextCanonical = canonical || SITE_URL;

    document.title = nextTitle;
    upsertLink("canonical", nextCanonical);

    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", "index, follow");

    upsertMeta("property", "og:title", nextTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", nextCanonical);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:site_name", "Orion Intelligence");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", nextTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    const id = "route-json-ld";
    let script = document.getElementById(id);
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = id;
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, canonical, image, type, jsonLd]);

  return null;
}
